"use client"

import React, {useEffect, useState} from 'react';
import Header2 from "@/app/(index)/header2";
import cx from "clsx";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Alert, Button, Image, Input, SimpleGrid, UnstyledButton} from "@mantine/core";
import {ReadMoreNoLink} from "@/app/(index)/read-more";
import {useMediaQuery} from "@mantine/hooks";
import {IconMailX, IconMoodCry, IconMoodSmile} from "@tabler/icons-react";
import {subscribeOrUnsubscribeSubmit, unsubscriptionSubmit} from "@/service";


const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const [email, setEmail] = useState<string>('');
    const [unsubscribeEmail, setUnsubscribeEmail] = useState<string | null>(null);
    const [subscribeResult, setSubscribeResult] = useState<number>(-2);
    const [subscribeEmail, setSubscribeEmail] = useState<string>('');

    const subscribeOrUnsubscribe = () => {
        subscribeOrUnsubscribeSubmit(email).then(setSubscribeResult).then(() => {
            const s1Email = JSON.stringify(email);
            const s2Email = JSON.parse(s1Email);
            setSubscribeEmail(s2Email);
            setEmail('');
        });
    }

    useEffect(() => {
        // console.log(`unsubscribe_id>>>>> ${unsubscribeId}`);
        //
        // if(unsubscribeId != null){
        //     unsubscriptionSubmit(unsubscribeId).then(setUnsubscribeEmail);
        // }
    }, [])

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="研究成果與出版品 - 電子報"/>
                    )
                }


                <div
                    className={cx("mx-auto mb-[60px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div
                        className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        {lang == "tw" ? "電子報" : "電子報"}
                    </div>

                    {/*{*/}
                    {/*    unsubscribeEmail !== null && (*/}
                    {/*        <Alert variant="light" color="red" title="取消訂閱電子報" icon={<IconMailX />} mb={"xl"}>*/}
                    {/*            <div className="text-lg text-red-700 flex gap-1">*/}
                    {/*                <div className="font-bold">{}</div>*/}
                    {/*                <div className="font-light">取消訂閱電子報成功</div>*/}
                    {/*            </div>*/}
                    {/*        </Alert>*/}
                    {/*    )*/}
                    {/*}*/}


                    <div className="flex flex-col">
                        <div className="flex justify-between">
                            <div className={cx("flex flex-col", mediaQueryLessSM ? 'w-[57%]' : 'w-full')}>
                                <div className="text-[20px]">歡迎訂閱</div>
                                <div className="text-[#8d7f4c] text-[46px] font-bold leading-[52px]">STPI電子報｜科政新訊</div>

                                <div className={cx("flex pt-3 items-center gap-3", mediaQueryLessSM ? "" : "flex-col")}>
                                    <div className={cx(mediaQueryLessSM ? "flex-1" : "w-full")}>
                                        {/*<input placeholder="請輸入您的電子郵件"*/}
                                        {/*       onChange={(event) => setEmail(event.currentTarget.value)}*/}
                                        {/*    className="outline-0 border-b border-[#8d7f4c] text-[18px] text-gray-600 py-[15px] w-full"/>*/}

                                        <Input variant="unstyled"
                                               placeholder="請輸入您的電子郵件"
                                               size={"lg"}
                                               value={email}
                                               width={"100%"}
                                               onChange={(event) => setEmail(event.currentTarget.value)}
                                               className="border-b border-[#8d7f4c] text-gray-600 py-[5px] w-full"/>

                                    </div>
                                    <Button color="#8d7f4c" radius="2" size="lg"
                                            fullWidth={!mediaQueryLessSM}
                                            onClick={subscribeOrUnsubscribe}>訂閱／取消訂閱</Button>
                                </div>

                                {
                                    subscribeResult >= 0 && (
                                        <div>
                                            <div className={cx("pt-1 flex gap-1 items-center text-lg", subscribeResult == 0 ? 'text-red-800' : 'text-green-800')}>


                                                {
                                                    subscribeResult == 0 ? (
                                                        <IconMoodCry size={22} stroke={1.5}/>
                                                    ) : (
                                                        <IconMoodSmile size={20} stroke={1.5}/>
                                                    )
                                                }
                                                <div className="font-black">{subscribeEmail}</div>
                                                <div className="font-light">{subscribeResult == 0 ? "取消訂閱成功" : "訂閱成功，感謝您的訂閱"}</div>

                                            </div>
                                        </div>
                                    )
                                }

                                <div className="flex mt-[50px]">
                                    <div className={cx("bg-[#1f5a60] text-white py-[13px] pr-[40px] pl-[30px] text-[17px] font-bold rounded-br-[30px]", mediaQueryLessSM ? '' : 'w-full')}>
                                        您必須訂閱科政新訊電子報的理由 :
                                    </div>
                                </div>

                                <div className={cx("mt-[30px] flex flex-col", mediaQueryLessSM ? 'pl-[30px] border-l border-dotted border-[#221231]' : '')}>
                                    <div className="text-[#1f5a60] text-[26px] font-extrabold">掌握國家科技政策動向</div>
                                    <div className="text-black text-[18px]">深入解析最新科技政策，了解政府如何推動科技發展，助您在產業變革中領先一步！</div>
                                    <div className="text-[#1f5a60] text-[26px] font-extrabold pt-5">獲取第一手科技資訊</div>
                                    <div className="text-black text-[18px]">每期精選科技發展、研究突破與創新趨勢，讓您隨時掌握前沿資訊！</div>
                                    <div className="text-[#1f5a60] text-[26px] font-extrabold pt-5">免費訂閱，輕鬆獲取高價值內容</div>
                                    <div className="text-black text-[18px]">無需費用，每期自動寄送，輕鬆掌握國家科技發展趨勢，讓資訊為您所用！</div>
                                </div>
                            </div>

                            {
                                mediaQueryLessSM && (
                                    <div>
                                        <Image src={`/images/epaper.png`} w={500}/>
                                    </div>
                                )
                            }

                        </div>
                    </div>



                </div>

                <div className={cx("bg-[#f2f5f6] pt-[45px]", mediaQueryLessSM ? '' : 'px-[10px]')}>
                    <div className={cx("mx-auto pb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full px-[10px]')}>
                        <div className="font-bold text-[27px]">{lang == "tw" ? "中心相關電子報" : "中心相關電子報"}</div>
                        <div className="mt-[30px]">
                            <SimpleGrid cols={mediaQueryLessSM ? 4 : 1} className={"pt-[20px]"}>
                                <UnstyledButton className="flex flex-col group" component="a" target={"_blank"}
                                                href={"https://pride.stpi.niar.org.tw/index/epaper"}>
                                    <Image src={`/images/epaper-PRIDE.jpg`} w={mediaQueryLessSM ? 300 : "100%"} h={mediaQueryLessSM ? 300 : "100%"} radius={20} mb={10}
                                           className="border border-[#abd0cb]"/>
                                    <div
                                        className="text-[#158a83] text-[20px] font-bold group-hover:text-black">PRIDE政策研究指標資料庫
                                    </div>
                                    <div className="text-[#b6b6b6] text-[15px] font-bold">電子報</div>

                                    <div className="pt-[25px]">
                                        <ReadMoreNoLink name={"前往訂閱"}/>
                                    </div>
                                </UnstyledButton>
                                <UnstyledButton className="flex flex-col group" component="a" target={"_blank"}
                                                href={"https://outlook.stpi.niar.org.tw"}>
                                    <Image src={`/images/epaper-outlook.jpg`} w={mediaQueryLessSM ? 300 : "100%"} h={mediaQueryLessSM ? 300 : "100%"} radius={20} mb={10}
                                           className="border border-[#abd0cb]"/>
                                    <div
                                        className="text-[#158a83] text-[20px] font-bold group-hover:text-black">OUTLOOK科技發展觀測平台
                                    </div>
                                    <div className="text-[#b6b6b6] text-[15px] font-bold">電子報</div>

                                    <div className="pt-[25px]">
                                        <ReadMoreNoLink name={"前往訂閱"}/>
                                    </div>
                                </UnstyledButton>
                                <UnstyledButton className="flex flex-col group" component="a" target={"_blank"}
                                                href={"https://iknow.stpi.niar.org.tw/ePaper/Default.aspx"}>
                                    <Image src={`/images/epaper-iknow.jpg`} w={mediaQueryLessSM ? 300 : "100%"} h={mediaQueryLessSM ? 300 : "100%"} radius={20} mb={10}
                                           className="border border-[#abd0cb]"/>
                                    <div
                                        className="text-[#158a83] text-[20px] font-bold group-hover:text-black">科技產業資訊室iKnow
                                    </div>
                                    <div className="text-[#b6b6b6] text-[15px] font-bold">電子報</div>
                                    <div className="pt-[25px]">
                                        <ReadMoreNoLink name={"前往訂閱"}/>
                                    </div>
                                </UnstyledButton>
                            </SimpleGrid>
                        </div>
                    </div>
                </div>



            </div>
            <Footer/>
        </div>
    );
}
